/* THE CALENDAR (Part20, owner 2026-08-28: "our own design system rather than the iOS native calendar, as we did in the sort
   menu"). A house date picker: a trigger styled as THE FIELD, THE RISE opening a paper panel - month line with two hairline
   arrows, the weekday row, a 7-column grid of 40px cells, the chosen day THE BLACK BUTTON, today a hairline box, days before
   `min` greyed and inert. One tap sets the date and closes; "Clear" removes it. Keyboard: arrows move a day / a week,
   PageUp/PageDown a month, Home/End the week's ends, Enter picks, Escape closes; one tab stop (roving tabindex).
   Contract: <div data-svnty-calendar data-min="YYYY-MM-DD" data-placeholder="Choose a date">
               <input type="hidden" data-cal-value name="...">
               <button type="button" class="svnty-field svnty-cal__trigger" data-cal-trigger aria-expanded="false" aria-controls="ID">…</button>
               <div class="svnty-cal__rise" id="ID" data-cal-rise aria-hidden="true"><div class="svnty-cal__rise-inner"><div class="svnty-cal" data-cal-panel></div></div></div>
             </div>
   Raises `svnty:calendar:change` (detail {value}) on the root. Multi-instance; re-binds on shopify:section:load. */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MON3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var parse = function (s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || ''); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; };
  var same = function (a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); };
  var pretty = function (d) { return MON3[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); };   /* US English (P17-27): Sep 30, 2026 */
  var today = function () { var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); };

  function setup(root) {
    if (root.dataset.calBound) return;
    root.dataset.calBound = '1';
    var input = root.querySelector('[data-cal-value]');
    var trigger = root.querySelector('[data-cal-trigger]');
    var rise = root.querySelector('[data-cal-rise]');
    var panel = root.querySelector('[data-cal-panel]');
    if (!input || !trigger || !rise || !panel) return;
    var placeholder = root.dataset.placeholder || 'Choose a date';
    var min = parse(root.dataset.min) || today();
    var max = parse(root.dataset.max) || new Date(min.getFullYear() + 1, min.getMonth(), min.getDate());
    var value = parse(input.value);
    if (!value && root.dataset.default === 'today') { var t0 = today(); if (t0 >= min && t0 <= max) { value = t0; input.value = iso(t0); } }
    var start = parse(root.dataset.start);
    var anchor = value || (start && start >= min && start <= max ? start : (min > today() ? min : (max < today() ? max : today())));
    var view = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
    var focusDay = anchor;
    var open = false;
    var mode = 'days';            /* 'days' | 'months' | 'years' - the native picker's grammar: tap the month for the months, the year for the years */

    var paintTrigger = function () {
      var label = trigger.querySelector('[data-cal-label]') || trigger;
      label.textContent = value ? pretty(value) : placeholder;
      trigger.classList.toggle('is-set', !!value);
    };
    var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };

    var render = function () {
      panel.innerHTML = '';
      var head = el('div', 'svnty-cal__head');
      var prev = el('button', 'svnty-cal__nav', ''); prev.type = 'button'; prev.setAttribute('aria-label', 'Previous month');
      prev.innerHTML = (window.SVNTY && SVNTY.iconHTML) ? SVNTY.iconHTML('chevron-left', 12, 1.05) : '';  /* THE ICON LAW (D11-3) */
      var next = el('button', 'svnty-cal__nav', ''); next.type = 'button'; next.setAttribute('aria-label', 'Next month');
      next.innerHTML = (window.SVNTY && SVNTY.iconHTML) ? SVNTY.iconHTML('chevron', 12, 1.05) : '';  /* THE ICON LAW (D11-3) */
      var title = el('button', 'svnty-cal__month', mode === 'years' ? (Math.floor(view.getFullYear() / 12) * 12) + ' to ' + (Math.floor(view.getFullYear() / 12) * 12 + 11) : mode === 'months' ? String(view.getFullYear()) : MONTHS[view.getMonth()] + ' ' + view.getFullYear()); title.type = 'button'; title.setAttribute('aria-live', 'polite');
      title.setAttribute('aria-label', mode === 'years' ? 'Back to the months' : mode === 'months' ? 'Choose a year' : 'Choose a month and year'); title.setAttribute('aria-expanded', mode === 'days' ? 'false' : 'true');
      title.addEventListener('click', function () { mode = mode === 'days' ? 'months' : mode === 'months' ? 'years' : 'months'; render(); var t = panel.querySelector('.svnty-cal__month'); if (t) t.focus(); });
      if (mode === 'years') {
        var base = Math.floor(view.getFullYear() / 12) * 12;
        prev.disabled = base <= min.getFullYear(); next.disabled = base + 11 >= max.getFullYear();
        prev.onclick = function () { view = new Date(view.getFullYear() - 12, view.getMonth(), 1); render(); }; prev.setAttribute('aria-label', 'Earlier years');
        next.onclick = function () { view = new Date(view.getFullYear() + 12, view.getMonth(), 1); render(); }; next.setAttribute('aria-label', 'Later years');
        head.appendChild(prev); head.appendChild(title); head.appendChild(next); panel.appendChild(head);
        var yg = el('div', 'svnty-cal__months'); yg.setAttribute('role', 'group'); yg.setAttribute('aria-label', 'Years');
        for (var yi = 0; yi < 12; yi++) {
          var y = base + yi; var yb = el('button', 'svnty-cal__mo', String(y)); yb.type = 'button';
          if (y < min.getFullYear() || y > max.getFullYear()) { yb.disabled = true; yb.classList.add('is-dead'); }
          if (y === (value || anchor).getFullYear()) yb.classList.add('is-active');
          (function (yy) { yb.addEventListener('click', function () { view = new Date(yy, Math.min(view.getMonth(), 11), 1); mode = 'months'; render(); var t = panel.querySelector('.svnty-cal__month'); if (t) t.focus(); }); })(y);
          yg.appendChild(yb);
        }
        panel.appendChild(yg);
        return;
      }
      if (mode === 'months') {
        prev.disabled = view.getFullYear() <= min.getFullYear(); next.disabled = view.getFullYear() >= max.getFullYear();
        prev.onclick = function () { view = new Date(view.getFullYear() - 1, view.getMonth(), 1); render(); }; prev.setAttribute('aria-label', 'Previous year');
        next.onclick = function () { view = new Date(view.getFullYear() + 1, view.getMonth(), 1); render(); }; next.setAttribute('aria-label', 'Next year');
        head.appendChild(prev); head.appendChild(title); head.appendChild(next); panel.appendChild(head);
        var mg = el('div', 'svnty-cal__months'); mg.setAttribute('role', 'group'); mg.setAttribute('aria-label', 'Months of ' + view.getFullYear());
        for (var mi = 0; mi < 12; mi++) {
          var mb = el('button', 'svnty-cal__mo', MON3[mi]); mb.type = 'button';
          var mFirst = new Date(view.getFullYear(), mi, 1), mLast = new Date(view.getFullYear(), mi + 1, 0);
          if (mLast < min || mFirst > max) { mb.disabled = true; mb.classList.add('is-dead'); }
          if (view.getFullYear() === (value || anchor).getFullYear() && mi === (value || anchor).getMonth()) mb.classList.add('is-active');
          (function (m) { mb.addEventListener('click', function () { view = new Date(view.getFullYear(), m, 1); focusDay = new Date(view.getFullYear(), m, 1); if (focusDay < min) focusDay = min; if (focusDay > max) focusDay = max; mode = 'days'; render(); var f = panel.querySelector('.svnty-cal__day[tabindex="0"]'); if (f) f.focus(); }); })(mi);
          mg.appendChild(mb);
        }
        panel.appendChild(mg);
        return;
      }
      var firstOfView = new Date(view.getFullYear(), view.getMonth(), 1), lastOfView = new Date(view.getFullYear(), view.getMonth() + 1, 0);
      prev.disabled = lastOfView < new Date(min.getFullYear(), min.getMonth(), 1) || firstOfView <= new Date(min.getFullYear(), min.getMonth(), 1);
      next.disabled = firstOfView >= new Date(max.getFullYear(), max.getMonth(), 1);
      prev.onclick = function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); focusDay = new Date(view.getFullYear(), view.getMonth(), Math.min(focusDay.getDate(), 28)); render(); var p = panel.querySelector('.svnty-cal__nav'); if (p) p.focus(); };
      next.onclick = function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); focusDay = new Date(view.getFullYear(), view.getMonth(), Math.min(focusDay.getDate(), 28)); render(); var ns = panel.querySelectorAll('.svnty-cal__nav'); if (ns[1]) ns[1].focus(); };
      head.appendChild(prev); head.appendChild(title); head.appendChild(next);
      panel.appendChild(head);

      var week = el('div', 'svnty-cal__week'); week.setAttribute('aria-hidden', 'true');
      DAYS.forEach(function (d) { week.appendChild(el('span', 'svnty-cal__wd', d)); });
      panel.appendChild(week);

      var grid = el('div', 'svnty-cal__grid'); grid.setAttribute('role', 'grid'); grid.setAttribute('aria-label', MONTHS[view.getMonth()] + ' ' + view.getFullYear());
      var lead = firstOfView.getDay();
      for (var i = 0; i < lead; i++) grid.appendChild(el('span', 'svnty-cal__pad'));
      var t = today();
      for (var d = 1; d <= lastOfView.getDate(); d++) {
        var date = new Date(view.getFullYear(), view.getMonth(), d);
        var b = el('button', 'svnty-cal__day', String(d)); b.type = 'button'; b.setAttribute('role', 'gridcell');
        var dead = date < min || date > max;
        if (dead) { b.disabled = true; b.classList.add('is-dead'); }
        if (same(date, t)) b.classList.add('is-today');
        if (same(date, value)) { b.classList.add('is-active'); b.setAttribute('aria-selected', 'true'); }
        b.tabIndex = same(date, focusDay) ? 0 : -1;
        b.dataset.date = iso(date);
        b.setAttribute('aria-label', pretty(date));
        grid.appendChild(b);
      }
      grid.addEventListener('click', function (e) { var b = e.target.closest('.svnty-cal__day'); if (!b || b.disabled) return; pick(parse(b.dataset.date)); });
      grid.addEventListener('keydown', onKey);
      panel.appendChild(grid);

      var foot = el('div', 'svnty-cal__foot');
      var clear = el('button', 'svnty-cal__clear', 'Clear'); clear.type = 'button'; clear.hidden = !value;
      clear.addEventListener('click', function () { pick(null); });
      foot.appendChild(clear);
      panel.appendChild(foot);
    };

    var onKey = function (e) {
      var b = e.target.closest ? e.target.closest('.svnty-cal__day') : null; if (!b) return;
      var cur = parse(b.dataset.date), n = null;
      if (e.key === 'ArrowRight') n = 1; else if (e.key === 'ArrowLeft') n = -1; else if (e.key === 'ArrowDown') n = 7; else if (e.key === 'ArrowUp') n = -7;
      else if (e.key === 'Home') n = -cur.getDay(); else if (e.key === 'End') n = 6 - cur.getDay();
      else if (e.key === 'PageDown') { e.preventDefault(); moveMonth(1); return; } else if (e.key === 'PageUp') { e.preventDefault(); moveMonth(-1); return; }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!b.disabled) pick(cur); return; }
      else if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (n === null) return;
      e.preventDefault();
      var nd = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + n);
      if (nd < min) nd = min; if (nd > max) nd = max;
      focusDay = nd;
      if (nd.getMonth() !== view.getMonth() || nd.getFullYear() !== view.getFullYear()) { view = new Date(nd.getFullYear(), nd.getMonth(), 1); render(); }
      var target = panel.querySelector('[data-date="' + iso(nd) + '"]');
      panel.querySelectorAll('.svnty-cal__day').forEach(function (x) { x.tabIndex = x === target ? 0 : -1; });
      if (target) target.focus();
    };
    var moveMonth = function (k) { view = new Date(view.getFullYear(), view.getMonth() + k, 1); focusDay = new Date(view.getFullYear(), view.getMonth(), 1); render(); var f = panel.querySelector('.svnty-cal__day[tabindex="0"]'); if (f) f.focus(); };

    var pick = function (d) {
      value = d; input.value = d ? iso(d) : '';
      paintTrigger();
      root.dispatchEvent(new CustomEvent('svnty:calendar:change', { bubbles: true, detail: { value: input.value } }));
      close(true);
    };
    var setOpen = function (on) {
      open = on;
      rise.classList.toggle('is-open', on);
      rise.setAttribute('aria-hidden', on ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      root.classList.toggle('is-open', on);
    };
    var close = function (focusTrigger) { if (!open) return; setOpen(false); if (focusTrigger) trigger.focus({ preventScroll: true }); };
    trigger.addEventListener('click', function () {
      if (open) { close(false); return; }
      view = new Date((value || anchor).getFullYear(), (value || anchor).getMonth(), 1); focusDay = value || anchor; mode = 'days';
      render(); setOpen(true);
      var f = panel.querySelector('.svnty-cal__day[tabindex="0"]'); if (f && trigger.matches(':focus-visible')) f.focus();
    });
    /* the close-on-outside runs on pointerdown, BEFORE a click can re-render the panel: a month or arrow that re-renders on
       click is no longer inside the root by the time the click bubbles, and a click listener would close the calendar */
    document.addEventListener('pointerdown', function (e) { if (open && !root.contains(e.target)) close(false); });
    document.addEventListener('focusin', function (e) { if (open && !root.contains(e.target)) close(false); });
    document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') close(true); });

    paintTrigger();
    setOpen(false);
  }
  var init = function () { document.querySelectorAll('[data-svnty-calendar]').forEach(setup); };
  init();
  document.addEventListener('shopify:section:load', init);
})();
